import { Environment } from './environment.types';

/**
 * To understand how process.env.NODE_ENV is being set when using create-react-app
 *
 * @see https://create-react-app.dev/docs/adding-custom-environment-variables/
 */

export const isProductionBuild = (): boolean => process.env.NODE_ENV === Environment.IS_PRODUCTION_BUILD;
